<template>
  <div class="dual-scroll" ref="wrapper">
    <div
      class="dual-scroll-track dual-scroll-track--top"
      ref="top"
      @scroll="handleScroll('top')"
    >
      <div
        class="dual-scroll-spacer"
        :style="{ width: `${contentWidth}px` }"
      ></div>
    </div>
    <div
      class="dual-scroll-track dual-scroll-track--bottom"
      ref="bottom"
      @scroll="handleScroll('bottom')"
    >
      <div class="dual-scroll-content" ref="content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DualScroll',
  data: () => ({
    contentWidth: 0,
    isSyncing: false,
  }),
  mounted() {
    this.$nextTick(() => {
      this.updateScrollWidth();
      window.addEventListener('resize', this.updateScrollWidth);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollWidth);
  },
  updated() {
    this.$nextTick(this.updateScrollWidth);
  },
  methods: {
    updateScrollWidth() {
      const content = this.$refs.content;
      const top = this.$refs.top;
      const bottom = this.$refs.bottom;

      if (!content || !top || !bottom) return;

      this.contentWidth = content.scrollWidth;
      top.scrollLeft = bottom.scrollLeft;
    },
    handleScroll(source) {
      if (this.isSyncing) return;

      const top = this.$refs.top;
      const bottom = this.$refs.bottom;

      this.isSyncing = true;
      if (source === 'top' && bottom && top) {
        bottom.scrollLeft = top.scrollLeft;
      } else if (source === 'bottom' && top && bottom) {
        top.scrollLeft = bottom.scrollLeft;
      }
      this.isSyncing = false;
    },
  },
};
</script>

<style scoped>
.dual-scroll {
  width: 100%;
}

.dual-scroll-track {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.4) transparent;
}

.dual-scroll-track--top {
  height: 16px;
  margin-bottom: 4px;
  border-bottom: 1px solid #dee2e6;
}

.dual-scroll-track--bottom {
  margin-top: 4px;
}

.dual-scroll-track::-webkit-scrollbar {
  height: 8px;
}

.dual-scroll-content {
  display: inline-block;
  min-width: 100%;
  white-space: nowrap;
}

.dual-scroll-spacer {
  height: 1px;
}
</style>

